import React, { Fragment, memo, useEffect, useState } from "react";
import styles from "../../assets/scss/authentication.module.scss";
import cx from "classnames";
import { Alert, Button, Form, Input, Select, Typography, Upload } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  CheckCircleOutlined,
  HomeOutlined,
  MailOutlined,
  MedicineBoxOutlined,
  NumberOutlined,
  SafetyCertificateOutlined,
  UploadOutlined,
  UserOutlined,
} from "@ant-design/icons";
import {
  calcInputSize,
  computeDisplayNameForZipCode,
  conditionalCheckForQualificationMatch,
  isAlphabets,
  isValidEmail,
  reloadPage,
} from "../../utilities";
import { isValidPhoneNumber } from "react-phone-number-input";
import MobileInput from "./MobileInput";
import {
  CITY_FOR_ZIP_CODE,
  FETCH_LISTINGS,
  REGISTER_USER,
  SEND_OTP,
  UPDATE_MOBILE_REQUEST,
} from "../../actions/types";
import OTP from "./OTP";
import { updateMobileService } from "../../services/authentications";
import NeedHelpModal from "../NeedHelpModal";
import QualificationModalBox from "../QualificationModalBox";
import { AppLocalStorage, AppStorageKeys } from "../../services/contracts";
// import ReCAPTCHA from "react-google-recaptcha";
import FloatLabelInput from "../common/FloatLabelInput";
import SpecialityIcon from "../../assets/images/speciality-icon.svg";
import QualificationIcon from "../../assets/images/qualification-cert-icon.svg";
import { uploadCustomFileSignUpService } from "../../services/apiServices";
import { SUPER_SIMPLE_AUTH_ORG_IDS } from "../../services/environments.js";

const { Option } = Select;
const { Title } = Typography;
const MIN_ZIP_CODE_LENGTH = 4;
const ZIP_CODE_ERROR_MESSAGE = "Please enter a valid Zip Code! (Optional)";
const EMAIL_ERROR_MESSAGE = "Please enter a valid email address!";
const MANDATORY_FIELDS_ERROR_MESSAGE = "Please fill this mandatory field!";
const OTHERS_INDEX_FOR_QUALIFICATIONS = 14;
const ROLE_IDS = [3];
const FormItem = Form.Item;

const TITLE_OPTIONS = [
  { value: "Dr.", id: 1 },
  { value: "Mr.", id: 2 },
  { value: "Ms.", id: 3 },
  { value: "Mrs.", id: 4 },
  { value: "Prof.", id: 5 },
];

export const CUSTOM_TYPES = {
  CONTENT_UPLOAD: "CONTENT_UPLOAD",
  DROPDOWN: "DROPDOWN",
  TEXT_BOX: "TEXT_BOX",
};

function Signup(props) {
  const {
    isAuthSwitched,
    closeAuth,
    signUpCaptchaRef,
    customFields,
    selectedData,
    setSelectedData,
    formsData,
    setFormsData,
    emailFromLogin,
    usingViaEmail,
  } = props;
  const [captchaValue, setCaptchaValue] = useState(false);
  const [tempOtherQualification, setTempOtherQualification] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [qualificationText, setQualificationText] = useState("");
  const [otherQualifications, setOtherQualifications] = useState([]);
  const [focused, setFocused] = useState({ field: "", isFocused: false });
  const [emailError, setEmailError] = useState("");
  const [displayNameForZipCode, setDisplayNameForZipCode] = useState("");
  const [isValidZipCode, setIsValidZipCode] = useState(true);
  const [showOtp, setShowOtp] = useState(false);
  const [selectedOtherQualification, setSelectedOtherQualification] =
    useState(false);
  const [isResendOtp, setIsResendOtp] = useState(false);
  const [isChangeNumber, setIsChangeNumber] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isServerError, setIsServerError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [newQualificationIndex, setNewQualificationIndex] = useState(-1);

  const authentications = useSelector((state) => state.authentications);
  const listings = useSelector((state) => state.listings);
  const { domainDetails } = useSelector((state) => state.listings);
  const dispatch = useDispatch();

  useEffect(() => {
    if (
      (authentications &&
        authentications.registered &&
        authentications.registered.responseCode === 200 &&
        !authentications.updateMobileRequest) ||
      (isResendOtp && !authentications.updateMobileRequest)
    ) {
      if (
        !checkForNonSimpleAuthOrgId() &&
        authentications.registered.accessToken
      ) {
        AppLocalStorage.save(
          AppStorageKeys.userAccessToken,
          authentications.registered.accessToken
        );
        closeAuth();
        reloadPage();
      } else {
        setShowOtp(true);
        setIsChangeNumber(false);
      }
    } else {
      setShowOtp(false);
    }
  }, [authentications]);

  useEffect(() => {
    dispatch({ type: FETCH_LISTINGS });
    setFormsData({
      ...formsData,
      country: authentications.mobileDetails.country,
    });
  }, []);

  useEffect(() => {
    getDisplayNameForZipCode();
  }, [authentications.cityForZipCode]);

  useEffect(() => {
    if (authentications.status && authentications.status !== "creating") {
      setIsServerError(
        authentications.registered &&
          authentications.registered.responseCode &&
          authentications.registered.responseCode !== 200
      );
    }
  }, [authentications.status]);

  useEffect(() => {
    getCityForZipCode();
  }, [zipCode, authentications.mobileDetails.country]);

  useEffect(() => {
    if (emailFromLogin) {
      setFormsData({ ...formsData, email: emailFromLogin });
    }
  }, [emailFromLogin]);

  const onChange = (value, name) => {
    if (Array.isArray(value)) {
      if (
        name === "qualificationIds" &&
        value.indexOf(OTHERS_INDEX_FOR_QUALIFICATIONS) >= 0
      ) {
        setSelectedOtherQualification(true);
      } else {
        setFormsData({ ...formsData, [name]: value });
      }
    } else if (name === "qualificationText") {
      setQualificationText(value);
    } else {
      setFormsData({ ...formsData, [name]: value });
    }
  };

  const onChangeOfSelectedData = (selected, key) => {
    setSelectedData({ ...selectedData, [key]: selected });
  };

  const onChangeOfImageData = (file, key) => {
    const formData = new FormData();
    formData.append("file", file);
    uploadCustomFileSignUpService(formData)
      .then((response) => {
        onChange(response.imageLink, key);
      })
      .catch((error) => {
        console.log(error);
      });
    return false;
  };

  const addOtherQualificationsToList = () => {
    if (tempOtherQualification && !getQualificationsMatchPresent()) {
      otherQualifications.push({
        id: newQualificationIndex,
        name: tempOtherQualification,
      });
      listings &&
        listings.data &&
        listings.data.qualifications &&
        listings.data.qualifications.length > 0 &&
        listings.data.qualifications.push({
          id: newQualificationIndex,
          name: tempOtherQualification,
        });
      let qualificationIds = [...formsData.qualificationIds];
      qualificationIds.push(newQualificationIndex);
      formsData.qualificationIds = qualificationIds;
      setNewQualificationIndex(newQualificationIndex - 1);
    }
    setSelectedOtherQualification(false);
    setTempOtherQualification("");
  };

  const onFocus = (name) => {
    setFocused({ field: name, isFocused: true });
  };

  const onBlur = () => {
    setFocused({ isFocused: false });
    if (formsData.email !== "" && !isValidEmail(formsData.email)) {
      setEmailError(EMAIL_ERROR_MESSAGE);
    } else {
      setEmailError("");
    }
  };

  const getCityForZipCode = () => {
    if (zipCode && zipCode.length >= MIN_ZIP_CODE_LENGTH) {
      dispatch({
        type: CITY_FOR_ZIP_CODE,
        payload: {
          zipCode: zipCode,
          countryCode:
            authentications &&
            authentications.mobileDetails &&
            authentications.mobileDetails.country
              ? authentications.mobileDetails.country
              : "IN",
        },
      });
    } else {
      setDisplayNameForZipCode("");
      setIsValidZipCode(true);
    }
  };

  const checkForValidZipCode = () => {
    const cityForZipCode =
      authentications.cityForZipCode &&
      authentications.cityForZipCode.length > 0
        ? authentications.cityForZipCode[0]
        : null;
    const check =
      (cityForZipCode && zipCode && zipCode.length >= MIN_ZIP_CODE_LENGTH) ||
      !zipCode;
    setIsValidZipCode(check);
    return check;
  };

  const getDisplayNameForZipCode = () => {
    const cityForZipCode =
      authentications.cityForZipCode &&
      authentications.cityForZipCode.length > 0
        ? authentications.cityForZipCode[0]
        : null;
    if (cityForZipCode) {
      setDisplayNameForZipCode(computeDisplayNameForZipCode(cityForZipCode));
      setIsValidZipCode(true);
    } else {
      setDisplayNameForZipCode("");
      setIsValidZipCode(true);
    }
  };

  const registerUser = () => {
    if (validateForm()) {
      setIsError(true);
      return false;
    } else if (!checkForValidZipCode()) {
      return false;
    } else {
      let registrationSourseRequest = navigator.appVersion;
      if (window.location.href.includes("/live/")) {
        var str = window.location.href;
        var index = str.lastIndexOf("/") + 1;
        var txt = str.substr(index);
        if (isNaN(txt)) {
          txt = txt.replace(/[^\d.-]/g, "");
        }
        registrationSourseRequest = "webinar341oc" + txt;
        let registrationSourceCodeFromLocalStorage = AppLocalStorage.get(
          AppStorageKeys.registrationSourceCode,
          true
        );
        if (
          registrationSourceCodeFromLocalStorage &&
          registrationSourceCodeFromLocalStorage.trim()
        ) {
          registrationSourseRequest =
            registrationSourceCodeFromLocalStorage.trim();
        }
      }
      let newOtherQualifications = [];
      formsData.qualificationIds.map((qualificationId) => {
        otherQualifications.map((otherQualification) => {
          if (otherQualification.id === qualificationId) {
            newOtherQualifications.push(otherQualification);
          }
        });
      });
      let customFieldsData = {};
      customFields.forEach((field) => {
        if (field.signupField.fieldType === CUSTOM_TYPES.DROPDOWN) {
          if (selectedData[field.id]) {
            customFieldsData[field.id] = field.isMultiselect
              ? selectedData[field.id].join(",")
              : selectedData[field.id];
          }
        } else {
          if (formsData[field.id]) {
            customFieldsData[field.id] = formsData[field.id];
          }
        }
      });
      dispatch({
        type: REGISTER_USER,
        payload: {
          firstName: formsData.firstName.trim(),
          lastName: formsData.lastName.trim(),
          mobileNumber: authentications.mobileDetails.nationalNumber,
          email: formsData.email,
          title: formsData.title,
          registrationRegionId: formsData.registrationRegionVal
            ? formsData.registrationRegionVal
            : "99",
          registrationId: formsData.registrationId
            ? formsData.registrationId
            : "MACLEODS_WEBINAR_123",
          specialities:
            !formsData.specialities || formsData.specialities.length === 0
              ? [20]
              : formsData.specialities,
          qualificationIds:
            !formsData.qualificationIds ||
            formsData.qualificationIds.length === 0
              ? [2]
              : formsData.qualificationIds,
          otherQualifications: newOtherQualifications,
          qualificationText: qualificationText.trim()
            ? qualificationText.trim()
            : "MBBS",
          zipCode: isValidZipCode ? zipCode : null,
          countryId: authentications.mobileDetails.countryId,
          registrationSource: registrationSourseRequest,
          isAllopathic: true,
          dob: "",
          site:
            domainDetails && domainDetails.orgType === "certifier"
              ? "microsite"
              : "docpro",
          organizationId: domainDetails.id,
          roleIds: ROLE_IDS,
          customFieldsMap: customFieldsData,
          skipOtp: !checkForNonSimpleAuthOrgId(),
        },
      });
    }
  };

  const updateNumber = () => {
    setLoading(true);
    const payload = {
      accessToken:
        authentications && authentications.registered.users.accessToken,
      mobileNum: authentications.mobileDetails.nationalNumber,
    };
    updateMobileService(payload)
      .then((response) => {
        if (response.responseCode === 200) {
          sendOtp();
          dispatch({
            type: UPDATE_MOBILE_REQUEST,
            payload: false,
          });
          setIsChangeNumber(false);
          setShowOtp(true);
          setLoading(false);
        }
      })
      .catch((error) => {
        setIsChangeNumber(true);
        console.log("Error", error);
      });
  };

  const validateAndHandleUpdateNumber = () => {
    if (
      authentications &&
      authentications.checkMobile.isUser !== "userExist" &&
      isValidPhoneNumber(authentications.mobileDetails.number)
    ) {
      updateNumber();
    }
  };

  const sendOtp = () => {
    dispatch({
      type: SEND_OTP,
      payload: {
        mobileNumber: authentications.mobileDetails.nationalNumber,
        site:
          domainDetails && domainDetails.orgType === "certifier"
            ? "microsite"
            : "docpro",
        countrySortName: authentications.mobileDetails.country,
        organizationId: domainDetails.id,
      },
    });
  };

  const validateForm = () => {
    let customFieldCheck = false;
    customFields.forEach((field) => {
      if (field.signupField.fieldType === CUSTOM_TYPES.DROPDOWN) {
        if (
          field.isMandatory &&
          (!selectedData[field.id] || selectedData[field.id].length === 0)
        ) {
          customFieldCheck = true;
        }
      } else {
        if (field.isMandatory && !formsData[field.id]) {
          customFieldCheck = true;
        }
      }
    });
    return (
      !authentications.mobileDetails.nationalNumber ||
      !isValidPhoneNumber(authentications.mobileDetails.number) ||
      formsData.firstName === "" ||
      formsData.lastName === "" ||
      // (authentications.mobileDetails.country === 'IN' && formsData.registrationId === '') ||
      (checkForNonSimpleAuthOrgId() &&
        (!formsData.specialities || formsData.specialities.length === 0)) ||
      (authentications.mobileDetails.country === "IN" &&
        checkForNonSimpleAuthOrgId() &&
        (!formsData.qualificationIds ||
          formsData.qualificationIds.length === 0)) ||
      (authentications.mobileDetails.country !== "IN" &&
        checkForNonSimpleAuthOrgId() &&
        !qualificationText) ||
      (authentications.mobileDetails.country === "IN" &&
        checkForNonSimpleAuthOrgId() &&
        !formsData.registrationId) ||
      (authentications.mobileDetails.country === "IN" &&
        checkForNonSimpleAuthOrgId() &&
        !formsData.registrationRegionVal) ||
      !isValidEmail(formsData.email) ||
      customFieldCheck
    );
  };

  const changeNumber = (value) => {
    setIsChangeNumber(value);
    setShowOtp(!value);
  };

  const isUserExist = (data) => {
    return data &&
      data.checkMobile &&
      data.checkMobile.isUser === "userExist" ? (
      <div className={styles.ml_10}>
        User already exist!{" "}
        <span
          onClick={() => isAuthSwitched(false)}
          className={styles.linkButton}
        >
          Login
        </span>
      </div>
    ) : null;
  };

  const getQualificationsMatchPresent = () => {
    let qualificationCheck = "";
    listings &&
      listings.data &&
      listings.data.qualifications &&
      listings.data.qualifications.length > 0 &&
      listings.data.qualifications.forEach((qualification) => {
        if (
          conditionalCheckForQualificationMatch(
            qualification.name,
            tempOtherQualification,
            true
          )
        ) {
          qualificationCheck = qualification.name;
        }
      });
    return qualificationCheck;
  };

  const addTheQualificationMatchToList = (qualificationName) => {
    listings &&
      listings.data &&
      listings.data.qualifications &&
      listings.data.qualifications.length > 0 &&
      listings.data.qualifications.forEach((qualification) => {
        if (qualification.name === qualificationName) {
          let qualificationIds = [...formsData.qualificationIds];
          qualificationIds.push(qualification.id);
          onChange(qualificationIds, "qualificationIds");
          setSelectedOtherQualification(false);
          setTempOtherQualification("");
        }
      });
  };

  const checkForNonSimpleAuthOrgId = () => {
    return !SUPER_SIMPLE_AUTH_ORG_IDS.includes(domainDetails.id);
  };

  return (
    <Fragment>
      <h1 className={cx(styles.auth_heading, styles.sign_up_mobile)}>
        Sign-up
      </h1>
      <p className={cx(styles.info_text, styles.sign_up_mobile)}>
        or{" "}
        <span
          onClick={() => isAuthSwitched(false)}
          className={cx(styles.link_button, styles.pointer)}
        >
          login to your account
        </span>
      </p>
      {authentications?.mobileDetails?.country !== "IN" && (
        <Alert
          message="OTP will be sent to your registered email."
          type="warning"
          showIcon
          style={{ marginBottom: 24 }}
        />
      )}
      {!showOtp && !isChangeNumber ? (
        <Fragment>
          <QualificationModalBox
            selectedOtherQualification={selectedOtherQualification}
            setSelectedOtherQualification={setSelectedOtherQualification}
            tempOtherQualification={tempOtherQualification}
            setTempOtherQualification={setTempOtherQualification}
            qualificationMatchPreset={getQualificationsMatchPresent()}
            addOtherQualificationsToList={addOtherQualificationsToList}
            addTheQualificationMatchToList={addTheQualificationMatchToList}
          />
          <div id="signup_form" className={styles.form_container_signup}>
            <FloatLabelInput
              label="First Name *"
              name="firstName"
              value={formsData.firstName}
              className="firstFloat"
            >
              <FormItem
                validateStatus={
                  isError && !formsData.firstName ? "error" : "success"
                }
                help={
                  isError && !formsData.firstName
                    ? MANDATORY_FIELDS_ERROR_MESSAGE
                    : ""
                }
              >
                <Input.Group compact>
                  <Input
                    value={formsData.firstName}
                    onChange={(e) => onChange(e.target.value, "firstName")}
                    onKeyDown={isAlphabets}
                    size={calcInputSize}
                    allowClear
                    autoComplete="none"
                    prefix={
                      <div
                        style={{
                          borderColor:
                            isError && !formsData.registrationRegionVal
                              ? "#f96161"
                              : "",
                          marginLeft: "-10px",
                        }}
                        className={`select_prefix ${
                          focused.isFocused &&
                          focused.field === "registrationRegionVal"
                            ? "focused"
                            : null
                        }`}
                      >
                        <div className="prefix">
                          <UserOutlined />
                        </div>{" "}
                        <Select
                          size={calcInputSize()}
                          bordered={false}
                          // showArrow={false}
                          onChange={(value) => onChange(value, "title")}
                          dropdownStyle={{ minWidth: "fit-content" }}
                          value={formsData.title}
                          defaultValue={TITLE_OPTIONS[0].value}
                        >
                          {TITLE_OPTIONS &&
                            TITLE_OPTIONS.map((title) => (
                              <Option key={title.id} value={title.value}>
                                {title.value}
                              </Option>
                            ))}
                        </Select>
                      </div>
                    }
                  />
                </Input.Group>
              </FormItem>
            </FloatLabelInput>
            <FloatLabelInput
              label="Last Name *"
              name="lastName"
              value={formsData.lastName}
            >
              <FormItem
                validateStatus={
                  isError && !formsData.lastName ? "error" : "success"
                }
                help={
                  isError && !formsData.lastName
                    ? MANDATORY_FIELDS_ERROR_MESSAGE
                    : ""
                }
              >
                <Input
                  value={formsData.lastName}
                  onChange={(e) => onChange(e.target.value, "lastName")}
                  onKeyDown={isAlphabets}
                  size={calcInputSize}
                  allowClear
                  autoComplete="none"
                  prefix={
                    <div className="prefix">
                      <UserOutlined />
                    </div>
                  }
                />
              </FormItem>
            </FloatLabelInput>
            <FloatLabelInput
              label="Email Address *"
              name="email"
              value={formsData.email}
            >
              <FormItem
                validateStatus={
                  emailError || (isError && !formsData.email)
                    ? "error"
                    : "success"
                }
                help={
                  emailError
                    ? emailError
                    : isError && !formsData.email
                    ? MANDATORY_FIELDS_ERROR_MESSAGE
                    : ""
                }
              >
                <Input
                  value={formsData.email}
                  onChange={(e) => onChange(e.target.value, "email")}
                  onBlur={onBlur}
                  size={calcInputSize}
                  allowClear
                  autoComplete="none"
                  prefix={
                    <div className="prefix">
                      <MailOutlined />
                    </div>
                  }
                  className={emailError ? styles.error_alert : null}
                />
              </FormItem>
            </FloatLabelInput>
            <div>
              <MobileInput
                isParentError={isError}
                validateAndHandleLogin={registerUser}
              />
              {isUserExist(authentications)}
            </div>
            {authentications &&
            authentications.mobileDetails &&
            authentications.mobileDetails.country === "IN" ? (
              <FloatLabelInput
                label={`Medical Registration State ${
                  checkForNonSimpleAuthOrgId() ? "*" : "(Optional)"
                }`}
                name="registrationRegionVal"
                value={formsData.registrationRegionVal}
              >
                <FormItem
                  validateStatus={
                    isError &&
                    !formsData.registrationRegionVal &&
                    checkForNonSimpleAuthOrgId()
                      ? "error"
                      : "success"
                  }
                  help={
                    isError &&
                    !formsData.registrationRegionVal &&
                    checkForNonSimpleAuthOrgId()
                      ? MANDATORY_FIELDS_ERROR_MESSAGE
                      : ""
                  }
                >
                  <div
                    style={{
                      borderColor:
                        isError && !formsData.registrationRegionVal
                          ? "#f96161"
                          : "",
                    }}
                    className={`select_prefix ${
                      focused.isFocused &&
                      focused.field === "registrationRegionVal"
                        ? "focused"
                        : null
                    }`}
                  >
                    <div className="prefix">
                      <HomeOutlined />
                    </div>
                    <Select
                      size={calcInputSize}
                      showSearch
                      optionFilterProp="children"
                      allowClear
                      autoComplete="none"
                      value={formsData.registrationRegionVal}
                      onChange={(value) =>
                        onChange(value, "registrationRegionVal")
                      }
                      onFocus={() => onFocus("registrationRegionVal")}
                      onBlur={onBlur}
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      virtual={false}
                    >
                      {listings &&
                        listings.data &&
                        listings.data.regions &&
                        listings.data.regions.length > 0 &&
                        listings.data.regions.map((region) => (
                          <Option key={region.code} value={region.code}>
                            {region.name}
                          </Option>
                        ))}
                    </Select>
                  </div>
                </FormItem>
              </FloatLabelInput>
            ) : null}
            {authentications &&
              authentications.mobileDetails &&
              authentications.mobileDetails.country === "IN" && (
                <FloatLabelInput
                  label={`Medical Registration ID ${
                    checkForNonSimpleAuthOrgId() ? "*" : "(Optional)"
                  }`}
                  name="registrationId"
                  value={formsData.registrationId}
                >
                  <FormItem
                    validateStatus={
                      isError &&
                      !formsData.registrationId &&
                      checkForNonSimpleAuthOrgId()
                        ? "error"
                        : "success"
                    }
                    help={
                      isError &&
                      !formsData.registrationId &&
                      checkForNonSimpleAuthOrgId()
                        ? MANDATORY_FIELDS_ERROR_MESSAGE
                        : ""
                    }
                  >
                    <Input
                      value={formsData.registrationId}
                      onChange={(e) =>
                        onChange(e.target.value, "registrationId")
                      }
                      size={calcInputSize}
                      allowClear
                      autoComplete="none"
                      prefix={
                        <div className="prefix">
                          <NumberOutlined />
                        </div>
                      }
                    />
                  </FormItem>
                </FloatLabelInput>
              )}
            <FloatLabelInput
              label={`Specialties of Interest ${
                checkForNonSimpleAuthOrgId() ? "*" : "(Optional)"
              }`}
              name="specialities"
              value={formsData.specialities}
            >
              <FormItem
                validateStatus={
                  isError &&
                  (!formsData.specialities ||
                    formsData.specialities.length === 0) &&
                  checkForNonSimpleAuthOrgId()
                    ? "error"
                    : "success"
                }
                help={
                  isError &&
                  (!formsData.specialities ||
                    formsData.specialities.length === 0) &&
                  checkForNonSimpleAuthOrgId()
                    ? MANDATORY_FIELDS_ERROR_MESSAGE
                    : ""
                }
              >
                <div
                  style={{
                    borderColor:
                      isError &&
                      (!formsData.specialities ||
                        formsData.specialities.length === 0) &&
                      checkForNonSimpleAuthOrgId()
                        ? "#f96161"
                        : "",
                  }}
                  className={`select_prefix ${
                    focused.isFocused && focused.field === "specialities"
                      ? "focused"
                      : null
                  }`}
                >
                  <div className="prefix">
                    <img src={SpecialityIcon} alt="" height="18px" />
                  </div>
                  <Select
                    size={calcInputSize}
                    showSearch
                    optionFilterProp="children"
                    mode="multiple"
                    showArrow
                    allowClear
                    autoComplete="none"
                    value={formsData.specialities}
                    onChange={(value) => onChange(value, "specialities")}
                    onFocus={() => onFocus("specialities")}
                    onBlur={onBlur}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    virtual={false}
                  >
                    {listings &&
                      listings.data &&
                      listings.data.specialities &&
                      listings.data.specialities.length > 0 &&
                      listings.data.specialities.map((speciality) =>
                        speciality.name !== "Others" ? (
                          <Option key={speciality.id} value={speciality.id}>
                            {speciality.name}
                          </Option>
                        ) : (
                          ""
                        )
                      )}
                  </Select>
                </div>
              </FormItem>
            </FloatLabelInput>
            {authentications &&
            authentications.mobileDetails &&
            authentications.mobileDetails.country !== "IN" ? (
              <FloatLabelInput
                label={`Qualification ${
                  checkForNonSimpleAuthOrgId() ? "*" : "(Optional)"
                }`}
                name="qualificationText"
                value={qualificationText}
              >
                <FormItem
                  validateStatus={
                    isError &&
                    !qualificationText &&
                    checkForNonSimpleAuthOrgId()
                      ? "error"
                      : "success"
                  }
                  help={
                    isError &&
                    !qualificationText &&
                    checkForNonSimpleAuthOrgId()
                      ? MANDATORY_FIELDS_ERROR_MESSAGE
                      : ""
                  }
                >
                  <Input
                    value={qualificationText}
                    onChange={(e) =>
                      onChange(e.target.value, "qualificationText")
                    }
                    size={calcInputSize}
                    allowClear
                    autoComplete="none"
                    prefix={
                      <div className="prefix">
                        <SafetyCertificateOutlined />
                      </div>
                    }
                  />
                </FormItem>
              </FloatLabelInput>
            ) : (
              <FloatLabelInput
                label={`Qualification ${
                  checkForNonSimpleAuthOrgId() ? "*" : "(Optional)"
                }`}
                name="qualificationIds"
                value={formsData.qualificationIds}
              >
                <FormItem
                  validateStatus={
                    isError &&
                    (!formsData.qualificationIds ||
                      formsData.qualificationIds.length === 0) &&
                    checkForNonSimpleAuthOrgId()
                      ? "error"
                      : "success"
                  }
                  help={
                    isError &&
                    (!formsData.qualificationIds ||
                      formsData.qualificationIds.length === 0) &&
                    checkForNonSimpleAuthOrgId()
                      ? MANDATORY_FIELDS_ERROR_MESSAGE
                      : ""
                  }
                >
                  <div
                    style={{
                      borderColor:
                        isError &&
                        (!formsData.qualificationIds ||
                          formsData.qualificationIds.length === 0) &&
                        checkForNonSimpleAuthOrgId()
                          ? "#f96161"
                          : "",
                    }}
                    className={`select_prefix ${
                      focused.isFocused && focused.field === "qualificationIds"
                        ? "focused"
                        : null
                    }`}
                  >
                    <div className="prefix">
                      <img src={QualificationIcon} alt="" height="18px" />
                    </div>
                    <Select
                      size={calcInputSize}
                      showSearch
                      optionFilterProp="children"
                      mode="multiple"
                      showArrow
                      allowClear
                      autoComplete="none"
                      notFoundContent='Please select "Others" option to add new qualification'
                      value={formsData.qualificationIds}
                      onChange={(value) => onChange(value, "qualificationIds")}
                      onFocus={() => onFocus("qualificationIds")}
                      onBlur={onBlur}
                      filterOption={(input, option) =>
                        conditionalCheckForQualificationMatch(
                          option.children,
                          input,
                          false
                        )
                      }
                      virtual={false}
                    >
                      {listings &&
                        listings.data &&
                        listings.data.qualifications &&
                        listings.data.qualifications.length > 0 &&
                        listings.data.qualifications.map((qualification) =>
                          qualification.name !== "Others" ? (
                            <Option
                              key={qualification.id}
                              value={qualification.id}
                            >
                              {qualification.name}
                            </Option>
                          ) : (
                            ""
                          )
                        )}
                      <Option
                        key={OTHERS_INDEX_FOR_QUALIFICATIONS}
                        value={OTHERS_INDEX_FOR_QUALIFICATIONS}
                      >
                        Others
                      </Option>
                    </Select>
                  </div>
                </FormItem>
              </FloatLabelInput>
            )}
            {authentications &&
              authentications.mobileDetails &&
              authentications.mobileDetails.country === "IN" && (
                <FloatLabelInput
                  label="Zip Code (Optional)"
                  name="zipCode"
                  value={zipCode}
                >
                  <FormItem
                    help={
                      isValidZipCode
                        ? displayNameForZipCode
                        : ZIP_CODE_ERROR_MESSAGE
                    }
                    validateStatus={!isValidZipCode ? "error" : "success"}
                  >
                    <Input
                      value={zipCode}
                      onChange={(e) =>
                        setZipCode(e.target.value ? e.target.value.trim() : "")
                      }
                      size={calcInputSize}
                      type="text"
                      validateStatus="error"
                      allowClear
                      autoComplete="none"
                      prefix={
                        <div className="prefix">
                          <MedicineBoxOutlined />
                        </div>
                      }
                    />
                    {/* {displayNameForZipCode ? <span className={!isValidZipCode ? styles.color_danger : styles.color_black_3}>{displayNameForZipCode}</span> : ''} */}
                  </FormItem>
                </FloatLabelInput>
              )}
            {customFields &&
              customFields.map((item) => {
                return item.signupField.fieldType !==
                  CUSTOM_TYPES.CONTENT_UPLOAD ? (
                  <FloatLabelInput
                    label={
                      item.signupField.fieldName +
                      (item.isMandatory ? " *" : "")
                    }
                    name={item.id}
                    value={
                      item.signupField.fieldType === CUSTOM_TYPES.DROPDOWN ||
                      item.signupField.fieldType === CUSTOM_TYPES.CONTENT_UPLOAD
                        ? selectedData[item.id]
                        : formsData[item.id]
                    }
                  >
                    {item.signupField.fieldType === CUSTOM_TYPES.DROPDOWN ? (
                      <FormItem
                        validateStatus={
                          isError &&
                          item.isMandatory &&
                          (!selectedData[item.id] ||
                            selectedData[item.id].length === 0)
                            ? "error"
                            : "success"
                        }
                        help={
                          isError &&
                          item.isMandatory &&
                          (!selectedData[item.id] ||
                            selectedData[item.id].length === 0)
                            ? MANDATORY_FIELDS_ERROR_MESSAGE
                            : ""
                        }
                      >
                        <div
                          style={{
                            borderColor:
                              isError &&
                              item.isMandatory &&
                              (!selectedData[item.id] ||
                                selectedData[item.id].length === 0)
                                ? "#f96161"
                                : "",
                          }}
                          className={`select_prefix ${
                            focused.isFocused && focused.field === item.id
                              ? "focused"
                              : null
                          }`}
                        >
                          <div className="prefix">
                            <CheckCircleOutlined />
                          </div>
                          <Select
                            size={calcInputSize}
                            showSearch
                            optionFilterProp="children"
                            allowClear
                            mode={item.isMultiselect ? "multiple" : "single"}
                            autoComplete="none"
                            value={selectedData[item.id]}
                            onChange={(value) =>
                              onChangeOfSelectedData(value, item.id)
                            }
                            onFocus={() => onFocus(item.id)}
                            onBlur={onBlur}
                            filterOption={(input, option) =>
                              option.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                            virtual={false}
                          >
                            {item.signupField.signupFieldOptions &&
                              item.signupField.signupFieldOptions.map(
                                (option) => (
                                  <Option
                                    key={item.id + "CUST" + option.id}
                                    value={option.id}
                                  >
                                    {option.optionText}
                                  </Option>
                                )
                              )}
                          </Select>
                        </div>
                      </FormItem>
                    ) : (
                      <FormItem
                        help={
                          isError && item.isMandatory && !formsData[item.id]
                            ? MANDATORY_FIELDS_ERROR_MESSAGE
                            : ""
                        }
                        validateStatus={
                          isError && item.isMandatory && !formsData[item.id]
                            ? "error"
                            : "success"
                        }
                      >
                        <Input
                          value={formsData[item.id]}
                          onChange={(e) => onChange(e.target.value, item.id)}
                          size={calcInputSize}
                          type="text"
                          validateStatus="error"
                          allowClear
                          autoComplete="none"
                          prefix={
                            <div className="prefix">
                              <CheckCircleOutlined />
                            </div>
                          }
                        />
                      </FormItem>
                    )}
                  </FloatLabelInput>
                ) : (
                  <FormItem
                    help={
                      isError && item.isMandatory && !formsData[item.id]
                        ? MANDATORY_FIELDS_ERROR_MESSAGE
                        : ""
                    }
                    validateStatus={
                      isError && item.isMandatory && !formsData[item.id]
                        ? "error"
                        : "success"
                    }
                  >
                    <Upload
                      accept="image/*,.pdf"
                      beforeUpload={(e) => onChangeOfImageData(e, item.id)}
                      maxCount={1}
                    >
                      <Button size="large" icon={<UploadOutlined />}>
                        {item.signupField.fieldName +
                          (item.isMandatory ? " *" : "")}
                      </Button>
                    </Upload>
                  </FormItem>
                );
              })}
          </div>
          {/* {isError ? <div key={Math.random()}><Alert closable onClose={() => setIsError(false)} message={MANDATORY_FIELDS_ERROR_MESSAGE} type='error' showIcon className={cx(styles.ml_10, styles.mr_10, styles.mt_10)} /></div> : null} */}
          {/* {!isValidZipCode ? <div key={Math.random()}><Alert closable onClose={() => setIsValidZipCode(true)} message={ZIP_CODE_ERROR_MESSAGE} type='error' showIcon className={cx(styles.ml_10, styles.mr_10, styles.mt_10)} /></div> : null} */}
          {isServerError ? (
            <div key={Math.random()}>
              <Alert
                closable
                onClose={() => setIsServerError(false)}
                message={authentications.registered.message}
                type="error"
                showIcon
                className={cx(styles.ml_10, styles.mr_10)}
              />
            </div>
          ) : null}
          <div className={styles.button_box} style={{ marginTop: 0 }}>
            {/* <ReCAPTCHA
              ref={signUpCaptchaRef}
              className={styles.mb_30}
              sitekey="6LcwlGodAAAAALl2E6Wa8_Ko8yJGy-g444AWssWp"
              onChange={(value) => setCaptchaValue(value)}
            /> */}
            <Button
              onClick={registerUser}
              block
              // disabled={captchaValue ? false : true}
              loading={authentications.status === "creating" ? true : false}
              className={styles.authButton}
            >
              SUBMIT &amp; PROCEED
            </Button>
          </div>
          {(domainDetails?.domainName === "rochewomenhealth" ||
            domainDetails?.domainName === "diabetesheartconnect") && (
            <p style={{ marginTop: 20, textAlign: "center", fontSize: 13 }}>
              By clicking 'Submit', you agree to share your contact details with
              Roche to receive further information
            </p>
          )}
          <p
            className={styles.trouble_box}
            style={{ padding: "0 10px 10px 10px" }}
          >
            Trouble signing up?{" "}
            <span
              onClick={() => setIsModalVisible(true)}
              className={styles.linkButton}
            >
              Click here
            </span>
          </p>
        </Fragment>
      ) : isChangeNumber ? (
        <div className={styles.change_number_container}>
          <Title level={5}>Enter your number</Title>
          <MobileInput validateAndHandleLogin={validateAndHandleUpdateNumber} />
          {isUserExist(authentications)}
          <button
            disabled={
              (authentications &&
                authentications.checkMobile.isUser === "userExist") ||
              !isValidPhoneNumber(authentications.mobileDetails.number)
                ? true
                : false
            }
            loading={loading ? true : false}
            onClick={updateNumber}
            block
            className={styles.authButton}
          >
            UPDATE &amp; PROCEED
          </button>
        </div>
      ) : (
        <OTP
          number={authentications && authentications.mobileDetails}
          email={
            authentications &&
            authentications.registered &&
            authentications.registered.users &&
            authentications.registered.users.email
          }
          closeAuth={closeAuth}
          changeNumber={changeNumber}
          setIsResendOtp={setIsResendOtp}
          changeNumberFor="signup"
          usingViaEmail={usingViaEmail}
        />
      )}
      <NeedHelpModal visible={isModalVisible} setVisible={setIsModalVisible} />
    </Fragment>
  );
}

export default memo(Signup);
